import MemberLoginPage from './MemberLoginPage';
export default MemberLoginPage;